import { render, staticRenderFns } from "./FormParametrizacao.vue?vue&type=template&id=85a3f80c"
import script from "./FormParametrizacao.vue?vue&type=script&lang=js"
export * from "./FormParametrizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports